var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 9.075C17.55 8.55 17.175 8.175 16.65 8.025C15.75 7.8 11.925 7.8 11.925 7.8C11.925 7.8 8.175 7.8 7.2 8.025C6.675 8.175 6.3 8.55 6.15 9.075C6 10.05 6 12 6 12C6 12 6 13.95 6.225 14.925C6.375 15.45 6.75 15.825 7.275 15.975C8.175 16.2 12 16.2 12 16.2C12 16.2 15.75 16.2 16.725 15.975C17.25 15.825 17.625 15.45 17.775 14.925C18 13.95 18 12 18 12C18 12 18 10.05 17.7 9.075ZM10.8 13.8V10.2L13.95 12L10.8 13.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ffde4104390269506def38bc0402e821.svg";
export { ForwardRef as ReactComponent };